(function () {
	'use strict';
	angular.module('app.leanProjects')
		.service('leanProjectAuthService', leanProjectAuthService);

	function leanProjectAuthService() {
		return {
			actionIsAllowed: actionIsAllowed
		};

		function userHasRole(roles, authzInfo) {
			return roles.indexOf(authzInfo.roleInProject) >= 0 ||
				(authzInfo.isAdmin && roles.indexOf('Admin') >= 0) ||
				(authzInfo.isGlobalApprover && roles.indexOf('GlobalApprover') >= 0) ||
				(authzInfo.isAreaApprover && roles.indexOf('AreaApprover') >= 0) ||
				(authzInfo.isCreator && roles.indexOf('Creator') >= 0) ||
				(authzInfo.isFinancialApprover && roles.indexOf('FinancialApprover') >= 0);
		}

		function actionIsAllowed(action, projectDetails, responsibleNdx) {
			var isAllowed = false;
			var projectIsPending = projectDetails.stageSequence === -1;
			var projectIsComplete = projectDetails.completeFlag === 1;
			var projectIsArchived = projectDetails.stageSequence === 1000;
			var isSupplier = globalConfig.user.role == 'Supplier';

			var authzInfo = projectDetails.authzInfo;

			if (authzInfo === undefined) {
				isAllowed = false;
			} else if (action === 'showAdvancedDates') {
				isAllowed = !isSupplier && (userHasRole(['Admin', 'AreaApprover', 'GlobalApprover'], authzInfo) ||
					userHasRole(['Project Manager', 'Project Administrator'], authzInfo));
			} else if (projectIsArchived && action !== 'editStage') {
				// only editing stage is allowed when project is archived
				isAllowed = false;
			} else if (action === 'editStage') {
				// only admin and approver allowed to approve (change from pending)
				isAllowed = !isSupplier && (userHasRole(['Admin', 'AreaApprover', 'GlobalApprover'], authzInfo) ||
					!projectIsPending && userHasRole(['Project Manager', 'Project Administrator', 'Project Sponsor'], authzInfo));
			} else if (action === 'editStartDate' ||
				action === 'editType' ||
				action === 'editSupplier' ||
				action === 'editCustomField' ||
				action === 'editGoals' ||
				action === 'editDescription' ||
				action === 'makeBestPractice' ||
				action === 'editProjectManager' ||
				action === 'editArea' ||
				action === 'editCategories' ||
				action === 'editEndDate' ||
				action === 'editProjectViewableBy' ||
				action === 'editProjectName') {
				isAllowed = !isSupplier && (userHasRole(['Admin', 'AreaApprover', 'GlobalApprover', 'Project Manager', 'Project Administrator', 'Project Sponsor'], authzInfo) ||
					userHasRole(['Creator'], authzInfo) && projectIsPending);
			} else if (action === 'completeProject') {
				// AKA Validate Project Results
				isAllowed = !isSupplier && userHasRole(['Admin', 'AreaApprover', 'GlobalApprover', 'FinancialApprover'], authzInfo);
			} else if (action === 'editTargetSavings') {
				isAllowed = !isSupplier && (userHasRole(['Admin', 'AreaApprover', 'GlobalApprover'], authzInfo) ||
					!projectIsComplete && userHasRole(['Project Manager', 'Project Administrator', 'Project Sponsor'], authzInfo) ||
					userHasRole(['Creator'], authzInfo) && projectIsPending);
			} else if (action === 'editActualSavings') {
				isAllowed = !isSupplier && ((!projectIsPending || userHasRole(['FinancialApprover'], authzInfo)) && (
					userHasRole(['Admin', 'AreaApprover', 'GlobalApprover', 'FinancialApprover'], authzInfo) ||
					!projectIsComplete && userHasRole(['Project Manager', 'Project Administrator', 'Project Sponsor'], authzInfo))
				);
			} else if (action === 'viewTask' ||
				action === 'viewIssue') {
				isAllowed = (!projectIsPending || action === 'viewTask') && (
					userHasRole(['Admin', 'Approver', 'GlobalApprover', 'FinancialApprover'], authzInfo) ||
					authzInfo.roleInProject ||
					!projectDetails.teamMembersOnly);
			} else if (action === 'addTask' ||
				action === 'addIssue') {
				isAllowed = !isSupplier && (!projectIsPending || action === 'addTask') && (
					userHasRole(['Admin', 'AreaApprover', 'GlobalApprover'], authzInfo) ||
					authzInfo.roleInProject);
			} else if (action === 'addAttachment') {
				isAllowed = !isSupplier && (userHasRole(['Admin', 'AreaApprover', 'GlobalApprover', 'FinancialApprover'], authzInfo) ||
					authzInfo.roleInProject || (projectIsPending && authzInfo.isCreator));
			} else if (action === 'deleteAttachment') {
				isAllowed = !isSupplier && (userHasRole(['Admin', 'AreaApprover', 'GlobalApprover', 'Project Manager', 'Project Administrator', 'Project Sponsor'], authzInfo) ||
					(projectIsPending && authzInfo.isCreator));
			} else if (action === 'editTask' ||
				action === 'editIssue') {
				isAllowed = (!projectIsPending || action === 'editTask') && (
					userHasRole(['Admin', 'AreaApprover', 'GlobalApprover', 'Project Manager', 'Project Administrator', 'Project Sponsor'], authzInfo) ||
					globalConfig.user.id === responsibleNdx);
			} else if (action === 'editTeamMembers' ||
				action === 'addTeamMember') {
				isAllowed = !isSupplier && !projectIsPending &&
					userHasRole(['Admin', 'AreaApprover', 'GlobalApprover', 'Project Manager', 'Project Administrator', 'Project Sponsor'], authzInfo);
			} else if (action === 'addMetric' ||
				action === 'editMetric') {
				isAllowed = !isSupplier && userHasRole(['Admin', 'AreaApprover', 'GlobalApprover', 'Project Manager', 'Project Administrator', 'Project Sponsor'], authzInfo);
			} else if (action === 'addTag') {
				isAllowed = !isSupplier && userHasRole(['Admin', 'GlobalApprover'], authzInfo);
			} else if (action === 'approveProject') {
				isAllowed = !isSupplier && projectIsPending && userHasRole(['Admin', 'AreaApprover', 'GlobalApprover'], authzInfo);
			}
			return isAllowed;
		}
	}
})();
